module.exports = __webpack_public_path__ + "img/userD07.fd940c07.jpg";